<template lang="pug">
  .select-list(:class="{'select-list-line': line}")
    transition-group(name="slide-fade")
      .input-container.arrow(v-for="(data, index) in dataForm[property]" :key="id[index]")
        select.select(v-model="dataForm[property][index]" autocomplete="ño" :required="required ? index + 1 <= required : false" @change="addInput(dataForm[property], index)" :class="{'next-input-optional': !data && index != 0}")
          option(v-for="option in options" :value="option") {{ caps !== false ? capitalize (option) : option }}

        label.label(:class="{ show: dataForm[property][index] }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" :property="property" :title="title" :index="index")

        .delete-button-select.times-icon.mini-button(@click="discard(dataForm[property], index)" v-show="required >= 0 ? required < index + 1 : true && (dataForm[property].length - 1 !== index)")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'

export default {
  name: 'SelectList',

  mixins: [mForm, mFilters],

  props: {
    dataForm: Object,
    dataOriginal: Object,
    fillData: Boolean,
    property: String,
    title: String,
    required: Number,
    options: Array,
    caps: Boolean,
    line: { type: Boolean, default: false }
  },

  data () {
    return {
      i: 0,
      id: [0]
    }
  },

  beforeUpdate () {
    this.initIdKeys()
    this.addInput()
  },

  created () {
    this.initIdKeys()
    this.addInputIfUpdate()
    this.addInputDependRequire()
    this.addIfNoLength()
  },

  methods: {
    initIdKeys () {
      if (Array.isArray(this.dataForm[this.property])) {
        this.i = this.dataForm[this.property].length || 0
        this.id = this.dataForm[this.property].map((_, index) => index)
      }
    },

    addInputIfUpdate (data = this.dataForm) {
      const array = data[this.property]

      const lastElement = array ? array[array.length - 1] : true

      if (this.fillData && lastElement) {
        this.pushEmpty(data[this.property])
      }
    },

    addInput (data = this.dataForm) {
      const array = data[this.property]

      if (array) {
        const lastElement = array[array.length - 1]

        if (lastElement) {
          this.pushEmpty(data[this.property])
        }
      }
    },

    addInputDependRequire (data = this.dataForm) {
      if (!this.fillData && (this.required !== 0)) {
        for (let i = 1; i < this.required; i++) {
          this.pushEmpty(data[this.property])
        }
      }
    },

    addIfNoLength () {
      if (!this.dataForm[this.property]) this.dataForm[this.property] = []
      const array = this.dataForm[this.property]
      if (!array.length) this.pushEmpty(array)
    }
  },

  watch: {
    dataForm: {
      handler (newVal, oldVal) {
        const diferenceLength = newVal[this.property].length - oldVal[this.property].length

        if (diferenceLength > 0) {
          for (let i = 0; i < diferenceLength; i++) {
            this.id.push(this.i++)
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.select-list
  width 100%
  position relative

.delete-button-select
  position absolute
  right 3em
  bottom .9rem
  z-index 11

.select-list-line > span
  display flex
  gap 1em
  flex-wrap wrap

.select-list-line .select,
.select-list-line .input-container
  width 20rem
</style>



// WEBPACK FOOTER //
// src/components/elements/SelectList.vue